import { Body, Button } from '@teko/ds-mobile';
import { styled } from '@teko/ui';
import { useProductDetailState, useTenantConfig } from 'contexts';

export const UomItem: React.FC = () => {
  const { product } = useProductDetailState();
  const { epicOmni1643 } = useTenantConfig();
  return epicOmni1643 ? (
    <Button
      variant="primary"
      border="1px solid primary500"
      color="textTitle"
      borderRadius="s"
      padding="s8"
      height="36px"
      backgroundColor="white"
    >
      <Body level={1} minWidth={56}>
        {product?.uomName}
      </Body>
      <Corner />
    </Button>
  ) : (
    <StyledButton>
      <Body level={1}>{product?.uomName}</Body>
      <div className="corner" />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  position: relative;
  display: inline-block;
  padding: 8px;
  border: 1px solid #0200bc; /* viền xanh */
  border-radius: 8px; /* bo góc */
  background: #fff;
  font-size: 16px;
  color: #000;
  cursor: pointer;
  overflow: hidden;
  min-width: 72px;
  height: 36px;

  .corner {
    content: '';
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 18px;
    height: 18px;
    background: #0200bc; /* màu góc gấp */
    clip-path: polygon(100% 0, 0 100%, 100% 100%);
  }
  .corner::after {
    height: 8px;
    content: '✔';
    position: absolute;
    bottom: 8px;
    right: 2px;
    font-size: 9px;
    line-height: 1.25rem; // set mobile & desktop to the same
    color: #fff;
  }
`;

const Corner = styled.div`
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 18px;
  height: 18px;
  background: #0200bc;
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.s};
  clip-path: polygon(100% 0, 0 100%, 100% 100%);

  &::after {
    content: '✔';
    position: absolute;
    bottom: -4px;
    right: 2px;
    font-size: 9px;
    color: #fff;
  }
`;
